<template>
  <GModal
    v-model="internalOpened"
    class="notas-g-modal"
    noPadding
    width="700"
    :title="modalTitle"
  >
    <TableV
      class="notas-table-v tabela-justificativas"
      :cols="atividadesCols"
      disablePagination
      height="auto"
      :rows="atividades"
    ></TableV>
  </GModal>
</template>

<script>
import TableV from "@/components/table-v";
import GModal from "@/components/g-modal";

const LIMITE_CONTEXTO = 40;

export default {
  name: "ModalAtividades",
  components: {
    TableV,
    GModal,
  },
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
    atividades: {
      type: Array,
      default: () => [],
    },
    contexto: {
      type: String,
      default: "",
    },
  },
  computed: {
    internalOpened: {
      get() {
        return this.opened;
      },
      set(val) {
        this.$emit("update:opened", val);
      },
    },
    modalTitle() {
      const base = "Descrições das atividades";
      if (!this.contexto) return base;
      const contexto =
        this.contexto.length > LIMITE_CONTEXTO
          ? this.contexto.slice(0, LIMITE_CONTEXTO).trim() + "…"
          : this.contexto;
      return `${base} — ${contexto}`;
    },
    atividadesCols: function () {
      return [
        {
          name: "Atividade",
          key: "descricao",
          width: "30%",
        },
        {
          name: "Horas reportadas",
          key: "horas",
          width: "20%",
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.notas-table-v {
  min-width: 500px;

  ::v-deep .v-data-table__wrapper {
    height: unset !important;
  }
}
</style>
